import { render, staticRenderFns } from "./SysMenu.vue?vue&type=template&id=161fb4f6&scoped=true"
import script from "./SysMenu.vue?vue&type=script&lang=js"
export * from "./SysMenu.vue?vue&type=script&lang=js"
import style0 from "./SysMenu.vue?vue&type=style&index=0&id=161fb4f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161fb4f6",
  null
  
)

export default component.exports